import classNames from 'styles/utils/classNames';

export default function Tag({ text, className, appendClasses = true }: { text: string; className?: string, appendClasses?: boolean}) {
  return (
    <div
      className={classNames(
        appendClasses ? 'typography-product-button-label-small rounded-xl px-1 py-3 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary' : '',
        !!className && className,
      )}
    >
      {text}
    </div>
  );
}
